import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';

import { Helmet } from '@xing-com/crate-helmet';

import { MainPage } from './main-page';

const GlobalStyle = createGlobalStyle`
  body {
    overflow-x: hidden;
  }
`;

declare global {
  interface Window {
    xtp?: {
      xingTrk?: (event: string) => void;
    };
  }
}

const trackingPixel = `!function(n,t,i,e,c,d){n.xtp||(c=n.xtp={xingTrk:function(){c.queue.push(arguments)}},c.queue=[],d=t.createElement("script"),d.src=i,d.onload=e,d.async=!0,t.head.appendChild(d))}(window,document,"https://static.xingcdn.com/xingtrk/index.js",function(){xtp.init("912b1218-b280-431e-ba17-8d5ed1c4e94c")});`;

export const Component: React.FC = () => {
  useEffect(() => {
    const pageViewKey = 'page_view_tracked';

    // Check if the page view has already been tracked in this session
    if (!sessionStorage.getItem(pageViewKey)) {
      // Call the tracking pixel function to signal a page view
      if (window.xtp && window.xtp.xingTrk) {
        window.xtp.xingTrk('page_views');
        // Set a flag in session storage to indicate that the page view has been tracked
        sessionStorage.setItem(pageViewKey, 'true');
      }
    }
  }, []);

  return (
    <>
      <Helmet>
        <script>{trackingPixel}</script>
      </Helmet>
      <GlobalStyle />
      <MainPage />
    </>
  );
};
